import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { FIB } from '@/config/constants';
var MENU_INSIGHT_MODE = FIB.MENU_INSIGHT_MODE;
import MenuInsightMajorGroup from "./MenuInsightsMajorGroupOffline";
import MenuInsightGrouped from "./MenuInsightsGroupedOffline";
import debounce from 'lodash/debounce';
export default {
  name: 'FibMenuInsightsQuestionOffline',
  components: {
    'menu-insight-major-group': MenuInsightMajorGroup,
    'menu-insight-grouped': MenuInsightGrouped
  },
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      groupedProducts: [],
      activeCategory: {},
      activeSubcategory: {},
      searchResults: [],
      loading: false
    };
  },
  computed: {
    products: function products() {
      return (this.$store.state.products || {}).downloadedProducts || {};
    },
    mode: function mode() {
      return this.question ? this.question.mode : MENU_INSIGHT_MODE.TYPE; // defaulting to mode 'type'
    },
    isGroupedType: function isGroupedType() {
      if (this.eposProducts.length === 0 && this.mode !== MENU_INSIGHT_MODE.MAJOR_GROUP) {
        return true;
      }

      return false;
    },
    questionType: function questionType() {
      if (this.isGroupedType) {
        return 'menu-insight-grouped';
      } else {
        return 'menu-insight-major-group';
      }
    },
    answers: function answers() {
      return this.$store.getters['answers/responses'] || {};
    },
    response: function response() {
      return this.answers["question".concat(this.question.id)] || [];
    },
    isApp: function isApp() {
      return this.$store.getters['config/isApp'];
    },
    eposProducts: function eposProducts() {
      return ((this.$store.state.checkIn.eposData || {}).transaction || {}).menuItems || [];
    }
  },
  mounted: function mounted() {
    if (this.eposProducts.length > 0) {
      this.groupedProducts = this.sortEposProducts();
    } else if (this.question.menuMajorGroupRef) {
      this.groupedProducts = this.sortProductsByMajorGroup(this.question.menuMajorGroupRef);
    } else if (this.question.menuFamilyGroupRef) {
      this.groupedProducts = this.sortProductsByFamilyGroup(this.question.menuFamilyGroupRef);
    } else {
      this.groupedProducts = this.sortGroupProducts();
    }
  },
  methods: {
    mapEachProduct: function mapEachProduct(products, majorGroups, familyGroups) {
      var _this = this;

      return products.map(function (product) {
        var matchingMajorGroup;
        var matchingFamilyGroup;

        if (product.type !== _this.question.menuType) {
          return null;
        }

        if (product.majorGroupId) {
          var productMajorId = product.majorGroupId;
          matchingMajorGroup = majorGroups.find(function (major) {
            return major.id === productMajorId;
          });
        }

        if (product.familyGroupId) {
          var productFamilyId = product.familyGroupId;
          matchingFamilyGroup = familyGroups.find(function (family) {
            return family.id === productFamilyId;
          });
        }

        if (!matchingFamilyGroup) {
          return null;
        }

        return {
          majorGroupName: (matchingMajorGroup || matchingFamilyGroup).name,
          majorGroupRef: matchingMajorGroup ? matchingMajorGroup.ref : "misc".concat(matchingFamilyGroup.ref),
          familyGroupName: (matchingFamilyGroup || {}).name,
          familyGroupRef: (matchingFamilyGroup || {}).ref,
          familyGroupWeight: (matchingFamilyGroup || {}).weight,
          name: product.name,
          ref: product.ref,
          id: product.id,
          type: product.type
        };
      }).filter(function (x) {
        return x !== null;
      }).sort(function (a, b) {
        return a.majorGroupRef - b.majorGroupRef || a.name.localeCompare(b.name);
      });
    },
    sortGroupProducts: function sortGroupProducts() {
      this.loading = true;
      var products = this.products.allProducts || [];
      var familyGroups = this.products.familyGroups || [];
      var majorGroups = this.products.majorGroups || []; // add family group and major group names and refs to all products

      var newProducts = this.mapEachProduct(products, majorGroups, familyGroups);
      var groupedProducts = [];
      newProducts.forEach(function (product) {
        var createProduct = {
          name: product.name,
          ref: product.ref,
          id: product.id,
          type: product.type
        }; // If there are no family groups matching the product family group create the nested object tree

        if (!groupedProducts.some(function (familyGroup) {
          return familyGroup.ref === product.familyGroupRef;
        })) {
          var familyGroupObj = {
            name: product.familyGroupName,
            ref: product.familyGroupRef,
            weight: product.familyGroupWeight,
            type: [product.type],
            majorGroups: [{
              name: product.majorGroupName,
              ref: product.majorGroupRef,
              type: [product.type],
              products: [createProduct]
            }]
          };
          groupedProducts.push(familyGroupObj);
        } else {
          // if there is a family group matching check if there is a major group matching.
          var index = groupedProducts.findIndex(function (familyGroup) {
            return familyGroup.ref === product.familyGroupRef;
          });
          var indexedFamilyGroup = groupedProducts[index]; // Check if there is a major group ref which matches the product major group ref

          var mgIndex = indexedFamilyGroup.majorGroups.findIndex(function (majorGroup) {
            return majorGroup.ref === product.majorGroupRef;
          });

          if (mgIndex === -1) {
            // If there is no major group found for the product then add the major group to the groupedFamilyGroups
            indexedFamilyGroup.majorGroups.push({
              name: product.majorGroupName,
              ref: product.majorGroupRef,
              type: [product.type],
              products: [createProduct]
            });
          } else {
            var indexedMajorGroup = indexedFamilyGroup.majorGroups[mgIndex]; // If the product type doesn't exist on the major group then add it
            // If the product type doesn't exist on the family group then add it

            if (!indexedMajorGroup.type.includes(product.type)) {
              indexedMajorGroup.type.push(product.type);
            }

            if (!indexedFamilyGroup.type.includes(product.type)) {
              indexedFamilyGroup.type.push(product.type);
            } // Push the product to the major group


            indexedMajorGroup.products.push(createProduct);
          }
        }
      });
      groupedProducts.forEach(function (fg) {
        return fg.majorGroups.sort(function (a, b) {
          return a.name > b.name ? 1 : -1;
        });
      });
      var sortedProducts = groupedProducts.sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      });
      this.loading = false;
      return sortedProducts;
    },
    sortProductsByMajorGroup: function sortProductsByMajorGroup(majorGroupRef) {
      this.loading = true;
      var products = this.products.allProducts || [];
      var majorGroups = this.products.majorGroups || [];
      var matchingMajorGroup = majorGroups.find(function (majorGroup) {
        return majorGroup.ref === majorGroupRef;
      });
      var grouped = [];

      if (matchingMajorGroup) {
        grouped = products.filter(function (product) {
          return product.majorGroupId === matchingMajorGroup.id;
        }).map(function (product) {
          return {
            majorGroupName: matchingMajorGroup.name,
            name: product.name,
            ref: product.ref,
            id: product.id,
            type: product.type
          };
        }).sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      }

      this.loading = false;
      return grouped;
    },
    sortProductsByFamilyGroup: function sortProductsByFamilyGroup(familyGroupRef) {
      this.loading = true;
      var products = this.products.allProducts || [];
      var majorGroups = this.products.majorGroups || [];
      var familyGroups = this.products.familyGroups || [];
      var matchingFamilyGroup = familyGroups.find(function (familyGroup) {
        return familyGroup.ref === familyGroupRef;
      });
      var grouped = [];

      if (!matchingFamilyGroup) {
        return;
      }

      grouped = products.filter(function (product) {
        return product.familyGroupId === matchingFamilyGroup.id;
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      var familyMajorGroups = [];
      grouped.forEach(function (product) {
        var createProduct = {
          name: product.name,
          ref: product.ref,
          id: product.id,
          type: product.type
        }; // See if there is the presense of the major group and if so get the index

        var mgIndex = familyMajorGroups.findIndex(function (majorGroup) {
          return majorGroup.id === product.majorGroupId;
        }); // Check against the index of the major group

        if (mgIndex === -1) {
          var matchingMajorGroupIndex = majorGroups.findIndex(function (major) {
            return major.id === product.majorGroupId;
          });

          if (matchingMajorGroupIndex > -1) {
            var matchingMajorGroup = majorGroups[matchingMajorGroupIndex]; // Add the major group to the array with the product added

            familyMajorGroups.push({
              name: matchingMajorGroup.name,
              ref: matchingMajorGroup.ref,
              id: matchingMajorGroup.id,
              type: [product.type],
              products: [createProduct]
            });
          }
        } else {
          // add the product to the major group
          familyMajorGroups[mgIndex].products.push(createProduct);
        }
      });
      familyMajorGroups.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      var familyGrouping = [{
        name: matchingFamilyGroup.name,
        ref: matchingFamilyGroup.ref,
        weight: matchingFamilyGroup.weight,
        type: [matchingFamilyGroup.type],
        majorGroups: familyMajorGroups
      }];
      this.loading = false;
      return familyGrouping;
    },
    sortEposProducts: function sortEposProducts() {
      var products = this.eposProducts;
      var familyGroup = this.question.menuFamilyGroupRef;
      var majorGroup = this.question.menuMajorGroupRef;
      var type = this.question.menuType; // Filter the products by Type/MajorGroupId/FamilyGroupId

      var filteredProducts = products.filter(function (product) {
        if (type) {
          if (product.type !== type) {
            return false;
          }
        }

        if (majorGroup) {
          if (product.majorGroupId !== majorGroup) {
            return false;
          }
        }

        if (familyGroup) {
          if (product.familyGroupId !== familyGroup) {
            return false;
          }
        }

        return true;
      }); // Map the eposData products to the object we expect in the MenuInsightsMajorGroup file.

      return filteredProducts.map(function (product) {
        return {
          majorGroupName: product.majorGroupName,
          name: product.menuItemName,
          ref: product.menuItemObjectNumber,
          id: product.menuItemObjectNumber,
          type: product.type
        };
      }).sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      });
    },
    onSearch: debounce(function (searchTerm) {
      if ((searchTerm || '').length > 2) {
        this.searchResults = this.getSearchResults(searchTerm);
      } else {
        this.searchResults = [];
      }
    }, 500),
    getSearchResults: function getSearchResults() {
      var searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var filtered = [];
      var lowercaseSearchTerm = searchTerm.toLowerCase();
      filtered = (this.products.allProducts || []).filter(function () {
        var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return (product.name || '').toLowerCase().includes(lowercaseSearchTerm);
      });
      return filtered;
    },
    clearSearch: function clearSearch() {
      this.searchResults = [];
    }
  }
};